export const REGIONAL_ADMIN = "RegionalAdmin"
export const GLOBAL_ADMIN = "GlobalAdmin"
export const CSR_BASIC = "CSRBasic"
export const CSR_ADVANCED = "CSRAdvanced"